import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import ChildrenInfoWorkflow from '../ChildrenInfoWorkflow/ChildrenInfoWorkflowContainer';
import AccountsWorkflow from '../AccountsWorkflow/AccountsWorkflowContainer';
import ExpensesWorkflow from '../ExpensesWorkflow/ExpensesWorkflowContainer';
import IncomeWorkflow from '../IncomeWorkflow/IncomeWorkflowContainer';
import TaxesWorkflow from '../TaxesWorkflow/TaxesWorkflowContainer';
import PartnerName from '../PersonalInfoWorkflow/Steps/PartnerNameContainer';
import Age from '../PersonalInfoWorkflow/Steps/AgeContainer';
import AreYouMarried from '../PersonalInfoWorkflow/Steps/AreYouMarriedContainer';
import EducationGoalsCRUD from './Steps/EducationGoalsCRUD/EducationGoalsCRUDContainer';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';

const EducationWorkflowView = ({
  workflowId,
  clientId,
  outputFunction,
  childFirstName,
  isMobile,
  childrenList,
  goToSummaryWhenReady,
  selectedGoalId,
  shouldSkipSummary,
  ...rest
}) => {
  useDocumentTitle('Save for Education');

  return (
    <AdvTopLevelWorkflow
      {...rest}
      selectedGoalId={selectedGoalId}
      clientId={clientId}
      hasAutoOutput={shouldSkipSummary}
      workflowId={workflowId}
      analyticsWorkflowStarted="education_workflow_started"
      outputFunction={outputFunction(clientId, childrenList, childFirstName)}
      steps={[
        EducationGoalsCRUD,
        AreYouMarried,
        PartnerName,
        Age,
        TaxesWorkflow,
        IncomeWorkflow,
        ExpensesWorkflow,
        ChildrenInfoWorkflow,
        AccountsWorkflow,
      ]}
    />
  );
};

EducationWorkflowView.defaultProps = {};

EducationWorkflowView.propTypes = {
  outputFunction: PropTypes.func.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  childFirstName: PropTypes.string.isRequired,
  childrenList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default EducationWorkflowView;
